import React from 'react'
import { Box } from "@mui/material"

import { AppLinksBlock } from "@components"

export default function downloadColumn() {

	return {
		name: 'name',
		render: (
			value, {
				hasLinkGeneration,
				hasLinkExport,
				report_url,
				export_url,
				status,
				id_report_execution,
				showForceButton
			}) => {
			return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<AppLinksBlock
					showForceButton={showForceButton}
					reportExecutionID={id_report_execution}
					downReport={{ hasGenerate: hasLinkGeneration, report_url: report_url }}
					downExport={{ hasExport: hasLinkExport, export_url: export_url }}
					isRunning={status === 'running'}
					downMultiReport={false}
					downMultiExport={false}
					showHistory={false}
					dor={false}
					lor={false}
					position={false}
				/>
			</Box>
		}
	}
}